import {ChangeDetectionStrategy, Component, OnDestroy} from '@angular/core';
import {CheckDeviceService} from './shared/components/check-mobile-device/check-device.service';
import {ViewLanguageService} from '@common-module/app-services/view-language.service';
import {AppCustomizationService} from "@common-module/app-services/app-customization.service";
import {AuthUserService} from "@common-module/app-services/auth-user.service";
import {EnvironmentHelper} from "@common-module/services/environment-helper";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class AppComponent implements OnDestroy {

  constructor(private checkDeviceService: CheckDeviceService,
              private authUserService: AuthUserService,
              private appCustomizationService: AppCustomizationService,
              private viewLanguageService: ViewLanguageService,
              private environmentHelper: EnvironmentHelper) {
  }

  ngOnInit(): void {
    if(this.environmentHelper.showMobileDownload) {
      this.checkDeviceService.openDialog();
    }
    this.viewLanguageService.initCurrentLanguage();
  }

  ngOnDestroy() {
    this.appCustomizationService.destroy();
    this.authUserService.destroy();
  }
}
